import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetPatientLatestGfrLab(patientId: string | undefined) {
  return useQuery(queries.patients.getPatientLatestGfr(patientId || ''))
}
